import styled from 'styled-components';
import { ErrorMessage } from 'styles/Styles.styled';

export const StyledInputWrapper = styled.div`
  position: relative;
  margin-bottom: 1rem;
`;

export const StyledInputErrorMessage = styled(ErrorMessage)`
  margin: 0;
  position: absolute;
  top: 100%;
  left: 0;
`;
